import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Slide from "@material-ui/core/Slide";
import GoogleMapAPI from "./google_maps";
import { connect } from "react-redux";

const styles = {
  appBar: {
    position: "relative"
  },
  flex: {
    flex: 1
  }
};

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class FullScreenDialog extends React.Component {
  state = {
    open: false
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.GoogleMapsReducer &&
      this.props.getLatLong(
        `${this.props.GoogleMapsReducer.Lat}, ${
          this.props.GoogleMapsReducer.Long
        }`
      );
  };

  renderLatLong = () => {
    return (
      <Fragment>
        {" "}
        {`Lat: ${this.props.GoogleMapsReducer.Lat}   Long: ${
          this.props.GoogleMapsReducer.Long
        }`}
      </Fragment>
    );
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <img
          id="googleMap"
          onClick={this.handleClickOpen}
          src={require("../assets/google.png")}
          alt="google"
          width="75%"
          height="auto"
        />
        <Dialog
          fullScreen
          open={this.state.open}
          onClose={this.handleClose}
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <Typography
                variant="button"
                color="inherit"
                className={classes.flex}
                onClick={this.handleClose}
              >
                SAVE
              </Typography>

              <Typography
                variant="subheading"
                color="inherit"
                className={classes.flex}
              >
                {this.props.GoogleMapsReducer && this.renderLatLong()}
              </Typography>

              <Typography
                variant="button"
                color="inherit"
                className={classes.flex}
                onClick={() => this.setState({ open: false })}
              >
                CANCEL
              </Typography>
            </Toolbar>
          </AppBar>
          <GoogleMapAPI />
        </Dialog>
      </div>
    );
  }
}

FullScreenDialog.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(
  connect(({ GoogleMapsReducer }) => {
    return {
      GoogleMapsReducer
    };
  })(FullScreenDialog)
);



// WEBPACK FOOTER //
// ./src/components/googleMapsDialogs.jsx